import {AbstractModel} from '../abstract-model';
import {User} from '../user';
import {Document} from '../document';
import {Product} from '../product';

export class Asset extends AbstractModel {
  id: number | null = null;
  name: string | null = null;
  type: string | null = null;
  document: Document | null = null;
  user: User | null = null;
  product: Product | null = null;
  lang: string | null = null;
  createdAt: Date | null = null;
  updatedAt: Date | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.document) {
      this.document = new Document().deserialize(input.document);
    }

    if (input.user) {
      this.user = new User().deserialize(input.user);
    }

    if (input.product) {
      this.product = new Product().deserialize(input.product);
    }

    return this;
  }
}
